import { createI18n } from 'vue-i18n'

import en from './locales/en'
import sl from './locales/sl'

export type AvailableLocales = 'sl' | 'en'

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           localStorage.getItem('locale') || 'sl',
    fallbackLocale:   'en',
    messages:         { sl, en },
    availableLocales: ['sl', 'en'],

    // Slovene has four forms — 1 soba, 2 sobi, 3–4 sobe, 5+ sob — and they come round
    // again at 101, 102 … so the rule looks at the last two digits. Without it vue-i18n
    // would offer three forms (0 | 1 | other), which cannot say "2 sobi".
    pluralRules: {
        sl: (choice: number): number => {
            const tail = choice % 100

            if (tail === 1) return 0
            if (tail === 2) return 1
            if (tail === 3 || tail === 4) return 2

            return 3
        },
    },
})

export default i18n
